// extracted by mini-css-extract-plugin
export default {"messagingService":"MessagingService_messagingService__ZQAg+"};